import { CalendarModel } from '../models/calendar.model';

export const MOCK_SCHEDULE_TODAY = {
  activities: [
    {
      type: 'retorno',
      title: null,
      facName: 'Jards Macale',
      facId: 'FAC_ID',
      facColor: 3,
      hourStart: '09:00',
      hourEnd: null
    },
    {
      type: 'visita',
      title: null,
      facName: 'Elomar',
      facId: 'FAC_ID',
      facColor: 1,
      hourStart: '10:00',
      hourEnd: '10:30'
    },
    {
      type: 'evento',
      title: 'Reunião mensal',
      facName: null,
      facId: null,
      facColor: null,
      hourStart: '13:00',
      hourEnd: '16:00'
    },
    {
      type: 'tarefa',
      title: 'Iniciar campanha',
      facName: null,
      facId: null,
      facColor: null,
      hourStart: '16:30',
      hourEnd: null
    },
    {
      type: 'lembrete',
      title: 'Atualizar facs',
      facName: null,
      facId: null,
      facColor: null,
      hourStart: '17:00',
      hourEnd: null
    }
  ]
};

export const MOCK_SCHEDULE_RESULTS = {
  activities: [
    {
      day: 1,
      month: 1,
      year: 2020,
      type: 'evento',
      title: 'Reunião mensal',
      facName: null,
      facId: null,
      facColor: null,
      hourStart: '12:34',
      hourEnd: '12:34'
    },
    {
      day: 1,
      month: 1,
      year: 2020,
      type: 'tarefa',
      title: 'Reunião mensal',
      facName: null,
      facId: null,
      facColor: null,
      hourStart: '12:34',
      hourEnd: '12:34'
    },
    {
      day: 1,
      month: 1,
      year: 2020,
      type: 'lembrete',
      title: 'Reunião mensal',
      facName: null,
      facId: null,
      facColor: null,
      hourStart: '12:34',
      hourEnd: null
    },
    {
      day: 31,
      month: 1,
      year: 2020,
      type: 'retorno',
      title: 'Cliente',
      facName: null,
      facId: null,
      facColor: 1,
      hourStart: '12:34',
      hourEnd: null
    },
    {
      day: 31,
      month: 1,
      year: 2020,
      type: 'visita',
      title: 'Cliente',
      facName: null,
      facId: null,
      facColor: 2,
      hourStart: '12:34',
      hourEnd: '12:34'
    },
    {
      day: 1,
      month: 1,
      year: 2020,
      type: 'evento',
      title: 'Reunião mensal',
      facName: null,
      facId: null,
      facColor: null,
      hourStart: '12:34',
      hourEnd: '12:34'
    },
    {
      day: 1,
      month: 1,
      year: 2020,
      type: 'tarefa',
      title: 'Reunião mensal',
      facName: null,
      facId: null,
      facColor: null,
      hourStart: '12:34',
      hourEnd: '12:34'
    },
    {
      day: 1,
      month: 1,
      year: 2020,
      type: 'lembrete',
      title: 'Reunião mensal',
      facName: null,
      facId: null,
      facColor: null,
      hourStart: '12:34',
      hourEnd: null
    },
    {
      day: 31,
      month: 1,
      year: 2020,
      type: 'retorno',
      title: 'Cliente',
      facName: null,
      facId: null,
      facColor: 1,
      hourStart: '12:34',
      hourEnd: null
    },
    {
      day: 31,
      month: 1,
      year: 2020,
      type: 'visita',
      title: 'Cliente',
      facName: null,
      facId: null,
      facColor: 2,
      hourStart: '12:34',
      hourEnd: '12:34'
    },
    {
      day: 1,
      month: 1,
      year: 2020,
      type: 'evento',
      title: 'Reunião mensal',
      facName: null,
      facId: null,
      facColor: null,
      hourStart: '12:34',
      hourEnd: '12:34'
    },
    {
      day: 1,
      month: 1,
      year: 2020,
      type: 'tarefa',
      title: 'Reunião mensal',
      facName: null,
      facId: null,
      facColor: null,
      hourStart: '12:34',
      hourEnd: '12:34'
    },
    {
      day: 1,
      month: 1,
      year: 2020,
      type: 'lembrete',
      title: 'Reunião mensal',
      facName: null,
      facId: null,
      facColor: null,
      hourStart: '12:34',
      hourEnd: null
    },
    {
      day: 31,
      month: 1,
      year: 2020,
      type: 'retorno',
      title: 'Cliente',
      facName: null,
      facId: null,
      facColor: 1,
      hourStart: '12:34',
      hourEnd: null
    },
    {
      day: 31,
      month: 1,
      year: 2020,
      type: 'visita',
      title: 'Cliente',
      facName: null,
      facId: null,
      facColor: 2,
      hourStart: '12:34',
      hourEnd: '12:34'
    }
  ]
};

export const MOCK_CALENDAR: CalendarModel = {
  today: { year: 2020, month: 7, day: 28 },
  years: [
    {
      year: 2019,
      months: [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        null,
        {
          month: 11,
          firstWeekDay: 0,
          weeks: [
            {
              week: 1,
              days: [
                { day: 1, marks: [] },
                { day: 2, marks: [] },
                { day: 3, marks: [] },
                { day: 4, marks: [] },
                { day: 5, marks: [] },
                { day: 6, marks: [] },
                { day: 7, marks: [] }
              ]
            },
            {
              week: 2,
              days: [
                { day: 8, marks: [] },
                { day: 9, marks: [] },
                { day: 10, marks: [] },
                { day: 11, marks: [] },
                { day: 12, marks: [] },
                { day: 13, marks: [] },
                { day: 14, marks: [] }
              ]
            },
            {
              week: 3,
              days: [
                { day: 15, marks: [] },
                { day: 16, marks: [] },
                { day: 17, marks: [] },
                { day: 18, marks: [] },
                { day: 19, marks: [] },
                { day: 20, marks: [] },
                { day: 21, marks: [] }
              ]
            },
            {
              week: 4,
              days: [
                { day: 22, marks: [] },
                { day: 23, marks: [] },
                { day: 24, marks: [] },
                { day: 25, marks: [] },
                { day: 26, marks: [] },
                { day: 27, marks: [] },
                { day: 28, marks: [] }
              ]
            },
            {
              week: 5,
              days: [
                { day: 29, marks: [] },
                { day: 30, marks: [] },
                { day: 31, marks: [] }
              ]
            }
          ]
        }
      ]
    },
    {
      year: 2020,
      months: [
        {
          month: 0,
          firstWeekDay: 3,
          weeks: [
            {
              week: 1,
              days: [
                { day: 1, marks: [] },
                { day: 2, marks: [] },
                { day: 3, marks: [] },
                { day: 4, marks: [] }
              ]
            },
            {
              week: 2,
              days: [
                { day: 5, marks: [] },
                { day: 6, marks: [] },
                { day: 7, marks: [] },
                { day: 8, marks: [] },
                { day: 9, marks: [] },
                { day: 10, marks: [] },
                { day: 11, marks: [] }
              ]
            },
            {
              week: 3,
              days: [
                { day: 12, marks: [] },
                { day: 13, marks: [] },
                { day: 14, marks: [] },
                { day: 15, marks: [] },
                { day: 16, marks: [] },
                { day: 17, marks: [] },
                { day: 18, marks: [] }
              ]
            },
            {
              week: 4,
              days: [
                { day: 19, marks: [] },
                { day: 20, marks: [] },
                { day: 21, marks: [] },
                { day: 22, marks: [] },
                { day: 23, marks: [] },
                { day: 24, marks: [] },
                { day: 25, marks: [] }
              ]
            },
            {
              week: 5,
              days: [
                { day: 26, marks: [] },
                { day: 27, marks: [] },
                { day: 28, marks: [] },
                { day: 29, marks: [] },
                { day: 30, marks: [] },
                { day: 31, marks: [] }
              ]
            }
          ]
        },
        {
          month: 1,
          firstWeekDay: 6,
          weeks: [
            {
              week: 1,
              days: [
                { day: 1, marks: [] }
              ]
            },
            {
              week: 2,
              days: [
                { day: 2, marks: [] },
                { day: 3, marks: [] },
                { day: 4, marks: [] },
                { day: 5, marks: [] },
                { day: 6, marks: [] },
                { day: 7, marks: [] },
                { day: 8, marks: [] }
              ]
            },
            {
              week: 3,
              days: [
                { day: 9, marks: [] },
                { day: 10, marks: [] },
                { day: 11, marks: [] },
                { day: 12, marks: [] },
                { day: 13, marks: [] },
                { day: 14, marks: [] },
                { day: 15, marks: [] }
              ]
            },
            {
              week: 4,
              days: [
                { day: 16, marks: [] },
                { day: 17, marks: [] },
                { day: 18, marks: [] },
                { day: 19, marks: [] },
                { day: 20, marks: [] },
                { day: 21, marks: [] },
                { day: 22, marks: [] }
              ]
            },
            {
              week: 5,
              days: [
                { day: 23, marks: [] },
                { day: 24, marks: [] },
                { day: 25, marks: [] },
                { day: 26, marks: [] },
                { day: 27, marks: [] },
                { day: 28, marks: [] },
                { day: 29, marks: [] }
              ]
            }
          ]
        },
        {
          month: 2,
          firstWeekDay: 0,
          weeks: [
            {
              week: 1,
              days: [
                { day: 1, marks: [] },
                { day: 2, marks: [] },
                { day: 3, marks: [] },
                { day: 4, marks: [] },
                { day: 5, marks: [] },
                { day: 6, marks: [] },
                { day: 7, marks: [] }
              ]
            },
            {
              week: 2,
              days: [
                { day: 8, marks: [] },
                { day: 9, marks: [] },
                { day: 10, marks: [] },
                { day: 11, marks: [] },
                { day: 12, marks: [] },
                { day: 13, marks: [] },
                { day: 14, marks: [] }
              ]
            },
            {
              week: 3,
              days: [
                { day: 15, marks: [] },
                { day: 16, marks: [] },
                { day: 17, marks: [] },
                { day: 18, marks: [] },
                { day: 19, marks: [] },
                { day: 20, marks: [] },
                { day: 21, marks: [] }
              ]
            },
            {
              week: 4,
              days: [
                { day: 22, marks: [] },
                { day: 23, marks: [] },
                { day: 24, marks: [] },
                { day: 25, marks: [] },
                { day: 26, marks: [] },
                { day: 27, marks: [] },
                { day: 28, marks: [] }
              ]
            },
            {
              week: 5,
              days: [
                { day: 29, marks: [] },
                { day: 30, marks: [] },
                { day: 31, marks: [] }
              ]
            }
          ]
        },
        {
          month: 3,
          firstWeekDay: 3,
          weeks: [
            {
              week: 1,
              days: [
                { day: 1, marks: [] },
                { day: 2, marks: [] },
                { day: 3, marks: [] },
                { day: 4, marks: [] }
              ]
            },
            {
              week: 2,
              days: [
                { day: 5, marks: [] },
                { day: 6, marks: [] },
                { day: 7, marks: [] },
                { day: 8, marks: [] },
                { day: 9, marks: [] },
                { day: 10, marks: [] },
                { day: 11, marks: [] }
              ]
            },
            {
              week: 3,
              days: [
                { day: 12, marks: [] },
                { day: 13, marks: [] },
                { day: 14, marks: [] },
                { day: 15, marks: [] },
                { day: 16, marks: [] },
                { day: 17, marks: [] },
                { day: 18, marks: [] }
              ]
            },
            {
              week: 4,
              days: [
                { day: 19, marks: [] },
                { day: 20, marks: [] },
                { day: 21, marks: [] },
                { day: 22, marks: [] },
                { day: 23, marks: [] },
                { day: 24, marks: [] },
                { day: 25, marks: [] }
              ]
            },
            {
              week: 5,
              days: [
                { day: 26, marks: [] },
                { day: 27, marks: [] },
                { day: 28, marks: [] },
                { day: 29, marks: [] },
                { day: 30, marks: [] }
              ]
            }
          ]
        },
        {
          month: 4,
          firstWeekDay: 5,
          weeks: [
            {
              week: 1,
              days: [
                { day: 1, marks: [] },
                { day: 2, marks: [] }
              ]
            },
            {
              week: 2,
              days: [
                { day: 3, marks: [] },
                { day: 4, marks: [] },
                { day: 5, marks: [] },
                { day: 6, marks: [] },
                { day: 7, marks: [] },
                { day: 8, marks: [] },
                { day: 9, marks: [] }
              ]
            },
            {
              week: 3,
              days: [
                { day: 10, marks: [] },
                { day: 11, marks: [] },
                { day: 12, marks: [] },
                { day: 13, marks: [] },
                { day: 14, marks: [] },
                { day: 15, marks: [] },
                { day: 16, marks: [] }
              ]
            },
            {
              week: 4,
              days: [
                { day: 17, marks: [] },
                { day: 18, marks: [] },
                { day: 19, marks: [] },
                { day: 20, marks: [] },
                { day: 21, marks: [] },
                { day: 22, marks: [] },
                { day: 23, marks: [] }
              ]
            },
            {
              week: 5,
              days: [
                { day: 24, marks: [] },
                { day: 25, marks: [] },
                { day: 26, marks: [] },
                { day: 27, marks: [] },
                { day: 28, marks: [] },
                { day: 29, marks: [] },
                { day: 30, marks: [] },
              ]
            },
            {
              week: 6,
              days: [
                { day: 31, marks: [] }
              ]
            }
          ]
        },
        {
          month: 5,
          firstWeekDay: 1,
          weeks: [
            {
              week: 1,
              days: [
                { day: 1, marks: [] },
                { day: 2, marks: [] },
                { day: 3, marks: [] },
                { day: 4, marks: [] },
                { day: 5, marks: [] },
                { day: 6, marks: [] }
              ]
            },
            {
              week: 2,
              days: [
                { day: 7, marks: [] },
                { day: 8, marks: [] },
                { day: 9, marks: [] },
                { day: 10, marks: [] },
                { day: 11, marks: [] },
                { day: 12, marks: [] },
                { day: 13, marks: [] }
              ]
            },
            {
              week: 3,
              days: [
                { day: 14, marks: [] },
                { day: 15, marks: [] },
                { day: 16, marks: [] },
                { day: 17, marks: [] },
                { day: 18, marks: [] },
                { day: 19, marks: [] },
                { day: 20, marks: [] }
              ]
            },
            {
              week: 4,
              days: [
                { day: 21, marks: [] },
                { day: 22, marks: [] },
                { day: 23, marks: [] },
                { day: 24, marks: [] },
                { day: 25, marks: [] },
                { day: 26, marks: [] },
                { day: 27, marks: [] }
              ]
            },
            {
              week: 5,
              days: [
                { day: 28, marks: [] },
                { day: 29, marks: [] },
                { day: 30, marks: [] }
              ]
            }
          ]
        },
        {
          month: 6,
          firstWeekDay: 3,
          weeks: [
            {
              week: 1,
              days: [
                { day: 1, marks: [] },
                { day: 2, marks: [] },
                { day: 3, marks: [] },
                { day: 4, marks: [] }
              ]
            },
            {
              week: 2,
              days: [
                { day: 5, marks: [] },
                { day: 6, marks: [] },
                { day: 7, marks: [] },
                { day: 8, marks: [] },
                { day: 9, marks: [] },
                { day: 10, marks: [] },
                { day: 11, marks: [] }
              ]
            },
            {
              week: 3,
              days: [
                { day: 12, marks: [] },
                { day: 13, marks: [] },
                { day: 14, marks: [] },
                { day: 15, marks: [] },
                { day: 16, marks: [] },
                { day: 17, marks: [] },
                { day: 18, marks: [] }
              ]
            },
            {
              week: 4,
              days: [
                { day: 19, marks: [] },
                { day: 20, marks: [] },
                { day: 21, marks: [] },
                { day: 22, marks: [] },
                { day: 23, marks: [] },
                { day: 24, marks: [] },
                { day: 25, marks: [] }
              ]
            },
            {
              week: 5,
              days: [
                { day: 26, marks: [] },
                { day: 27, marks: [] },
                { day: 28, marks: [] },
                { day: 29, marks: [] },
                { day: 30, marks: [] },
                { day: 31, marks: [] }
              ]
            }
          ]
        },
        {
          month: 7,
          firstWeekDay: 6,
          weeks: [
            {
              week: 1,
              days: [
                { day: 1, marks: [] }
              ]
            },
            {
              week: 2,
              days: [
                { day: 2, marks: [] },
                { day: 3, marks: [] },
                { day: 4, marks: [] },
                { day: 5, marks: [] },
                { day: 6, marks: [] },
                { day: 7, marks: [] },
                { day: 8, marks: [] }
              ]
            },
            {
              week: 3,
              days: [
                { day: 9, marks: [] },
                { day: 10, marks: [] },
                { day: 11, marks: [] },
                { day: 12, marks: [] },
                { day: 13, marks: [] },
                { day: 14, marks: [] },
                { day: 15, marks: [] }
              ]
            },
            {
              week: 4,
              days: [
                { day: 16, marks: [] },
                { day: 17, marks: [] },
                { day: 18, marks: [] },
                { day: 19, marks: [] },
                { day: 20, marks: [] },
                { day: 21, marks: [] },
                { day: 22, marks: [] }
              ]
            },
            {
              week: 5,
              days: [
                { day: 23, marks: [] },
                { day: 24, marks: [] },
                { day: 25, marks: [] },
                { day: 26, marks: [] },
                { day: 27, marks: [] },
                { day: 28, marks: [] },
                { day: 29, marks: [] }
              ]
            },
            {
              week: 6,
              days: [
                { day: 30, marks: [] },
                { day: 31, marks: [] }
              ]
            }
          ]
        },
        {
          month: 8,
          firstWeekDay: 2,
          weeks: [
            {
              week: 1,
              days: [
                { day: 1, marks: [] },
                { day: 2, marks: [] },
                { day: 3, marks: [] },
                { day: 4, marks: [] },
                { day: 5, marks: [] }
              ]
            },
            {
              week: 2,
              days: [
                { day: 6, marks: [] },
                { day: 7, marks: [
                  {
                    type: 'lembrete',
                    title: 'Atualizar facs',
                    facName: null,
                    facId: null,
                    date: '07/09/2020',
                    hourStart: '11:55',
                    hourEnd: null,
                    repeat: 'Toda semana (segunda-feira)',
                    notification: '5 minutos antes',
                    contactType: null,
                    place: null,
                    description: 'Descrição ou comentários sobre o lembrete.',
                    creator: { name: 'Hermeto Pascoal', email: 'hermeto@outlook.com' },
                    confirmed: null,
                    maybe: null,
                    absent: null,
                    noAnswer: null,
                    myAnswer: null
                  }
                ],
                special: [
                  { description: 'Dia da Independência' }
                ]},
                { day: 8, marks: [
                  {
                    type: 'tarefa',
                    title: 'Iniciar campanha',
                    facName: null,
                    facId: null,
                    date: '08/09/2020',
                    hourStart: '07:00',
                    hourEnd: '08:55',
                    repeat: null,
                    notification: '5 minutos antes',
                    contactType: null,
                    place: null,
                    description: 'Descrição ou comentários sobre a tarefa.',
                    creator: { name: 'Hermeto Pascoal', email: 'hermeto@outlook.com' },
                    confirmed: null,
                    maybe: null,
                    absent: null,
                    noAnswer: null,
                    myAnswer: null
                  }
                ]},
                { day: 9, marks: [
                  {
                    type: 'evento',
                    title: 'Reunião semanal',
                    facName: null,
                    facId: null,
                    date: '09/09/2020',
                    hourStart: '08:45',
                    hourEnd: '18:30',
                    repeat: 'Toda semana (quarta-feira)',
                    notification: '12 minutos antes',
                    contactType: null,
                    place: 'https://meeting.com',
                    description: 'Descrição ou comentários sobre o evento.',
                    creator: { name: 'Hermeto Pascoal', email: 'hermeto@outlook.com' },
                    confirmed: [
                      { name: 'Jorge Ben', email: 'ben@gmx.com' },
                      { name: 'Antonio Pecci', email: 'toquinho@uol.com.br' },
                      { name: 'Vinícius de Moraes', email: 'poeta@gmail.com' },
                      { name: 'Tim Maia', email: 'sindico@ig.com.br' }
                    ],
                    maybe: [
                      { name: 'Elis Regina', email: 'elis@ig.com.br' },
                      { name: 'Jards Macale', email: 'jards@gmail.com.br' }
                    ],
                    absent: [
                      { name: 'João Gilberto', email: 'contato@jg.com' }
                    ],
                    noAnswer: [
                      { name: 'Baden Powell', email: 'baden@gmail.com' },
                      { name: 'João Barone', email: 'barone@gmail.com' },
                      { name: 'Paulo Miklos', email: 'paulo@gmail.com' }
                    ],
                    myAnswer: null
                  }
                ]},
                { day: 10, marks: [
                  {
                    type: 'visita',
                    facName: 'Milton Nascimento',
                    facId: 'FAC_ID',
                    date: '10/09/2020',
                    hourStart: '07:20',
                    hourEnd: '08:30',
                    repeat: null,
                    notification: '30 minutos antes',
                    contactType: null,
                    place: 'Rua Estados Unidos, 2000 - Jardim América - São Paulo - SP',
                    description: 'Descrição ou comentários sobre a visita.',
                    creator: { name: 'Hermeto Pascoal', email: 'hermeto@outlook.com' },
                    confirmed: [
                      { name: 'Milton Nascimento', email: 'milton@outlook.com' }
                    ],
                    maybe: [],
                    absent: [],
                    noAnswer: [
                      { name: 'Lô Borges', email: 'lo@outlook.com' }
                    ],
                    myAnswer: null
                  }
                ]},
                { day: 11, marks: [
                  {
                    type: 'evento',
                    title: 'Follow up',
                    facName: null,
                    facId: null,
                    date: '11/09/2020',
                    hourStart: '08:00',
                    hourEnd: '12:00',
                    repeat: 'Todo mês (dia 11)',
                    notification: '30 minutos antes',
                    contactType: null,
                    place: 'https://meeting.com',
                    description: 'Descrição ou comentários sobre o evento.',
                    creator: { name: 'Tim Maia', email: 'sindico@ig.com.br' },
                    confirmed: [
                      { name: 'Jorge Ben', email: 'ben@gmx.com' },
                      { name: 'Vinícius de Moraes', email: 'poeta@gmail.com' },
                    ],
                    maybe: [
                      { name: 'Elis Regina', email: 'elis@ig.com.br' }
                    ],
                    absent: [],
                    noAnswer: [
                      { name: 'Hermeto Pascoal', email: 'hermeto@outlook.com' }
                    ],
                    myAnswer: 'noAnswer'
                  }
                ]},
                { day: 12, marks: [] }
              ]
            },
            {
              week: 3,
              days: [
                { day: 13, marks: [] },
                { day: 14, marks: [] },
                { day: 15, marks: [
                  {
                    type: 'retorno',
                    facName: 'Gilberto Gil',
                    facId: 'FAC_ID',
                    date: '15/09/2020',
                    hourStart: '10:00',
                    hourEnd: null,
                    repeat: null,
                    notification: '5 minutos antes',
                    contactType: 'Telefone',
                    place: null,
                    description: 'Descrição ou comentários sobre o retorno.',
                    creator: { name: 'Hermeto Pascoal', email: 'hermeto@outlook.com' },
                    confirmed: null,
                    maybe: null,
                    absent: null,
                    noAnswer: null,
                    myAnswer: null
                  }
                ]},
                { day: 16, marks: [] },
                { day: 17, marks: [] },
                { day: 18, marks: [] },
                { day: 19, marks: [] }
              ]
            },
            {
              week: 4,
              days: [
                { day: 20, marks: [] },
                { day: 21, marks: [] },
                { day: 22, marks: [] },
                { day: 23, marks: [] },
                { day: 24, marks: [] },
                { day: 25, marks: [] },
                { day: 26, marks: [] }
              ]
            },
            {
              week: 5,
              days: [
                { day: 27, marks: [] },
                { day: 28, marks: [] },
                { day: 29, marks: [] },
                { day: 30, marks: [] }
              ]
            }
          ]
        },
        {
          month: 9,
          firstWeekDay: 4,
          weeks: [
            {
              week: 1,
              days: [
                { day: 1, marks: [] },
                { day: 2, marks: [] },
                { day: 3, marks: [] }
              ]
            },
            {
              week: 2,
              days: [
                { day: 4, marks: [] },
                { day: 5, marks: [] },
                { day: 6, marks: [] },
                { day: 7, marks: [] },
                { day: 8, marks: [] },
                { day: 9, marks: [] },
                { day: 10, marks: [] }
              ]
            },
            {
              week: 3,
              days: [
                { day: 11, marks: [] },
                { day: 12, marks: [] },
                { day: 13, marks: [] },
                { day: 14, marks: [] },
                { day: 15, marks: [] },
                { day: 16, marks: [] },
                { day: 17, marks: [] }
              ]
            },
            {
              week: 4,
              days: [
                { day: 18, marks: [] },
                { day: 19, marks: [] },
                { day: 20, marks: [] },
                { day: 21, marks: [] },
                { day: 22, marks: [] },
                { day: 23, marks: [] },
                { day: 24, marks: [] }
              ]
            },
            {
              week: 5,
              days: [
                { day: 25, marks: [] },
                { day: 26, marks: [] },
                { day: 27, marks: [] },
                { day: 28, marks: [] },
                { day: 29, marks: [] },
                { day: 30, marks: [] },
                { day: 31, marks: [] }
              ]
            }
          ]
        },
        {
          month: 10,
          firstWeekDay: 0,
          weeks: [
            {
              week: 1,
              days: [
                { day: 1, marks: [] },
                { day: 2, marks: [] },
                { day: 3, marks: [] },
                { day: 4, marks: [] },
                { day: 5, marks: [] },
                { day: 6, marks: [] },
                { day: 7, marks: [] }
              ]
            },
            {
              week: 2,
              days: [
                { day: 8, marks: [] },
                { day: 9, marks: [] },
                { day: 10, marks: [] },
                { day: 11, marks: [] },
                { day: 12, marks: [] },
                { day: 13, marks: [] },
                { day: 14, marks: [] }
              ]
            },
            {
              week: 3,
              days: [
                { day: 15, marks: [] },
                { day: 16, marks: [] },
                { day: 17, marks: [] },
                { day: 18, marks: [] },
                { day: 19, marks: [] },
                { day: 20, marks: [] },
                { day: 21, marks: [] }
              ]
            },
            {
              week: 4,
              days: [
                { day: 22, marks: [] },
                { day: 23, marks: [] },
                { day: 24, marks: [] },
                { day: 25, marks: [] },
                { day: 26, marks: [] },
                { day: 27, marks: [] },
                { day: 28, marks: [] }
              ]
            },
            {
              week: 5,
              days: [
                { day: 29, marks: [] },
                { day: 30, marks: [] }
              ]
            }
          ]
        },
        {
          month: 11,
          firstWeekDay: 2,
          weeks: [
            {
              week: 1,
              days: [
                { day: 1, marks: [] },
                { day: 2, marks: [] },
                { day: 3, marks: [] },
                { day: 4, marks: [] },
                { day: 5, marks: [] }
              ]
            },
            {
              week: 2,
              days: [
                { day: 6, marks: [] },
                { day: 7, marks: [] },
                { day: 8, marks: [] },
                { day: 9, marks: [] },
                { day: 10, marks: [] },
                { day: 11, marks: [] },
                { day: 12, marks: [] }
              ]
            },
            {
              week: 3,
              days: [
                { day: 13, marks: [] },
                { day: 14, marks: [] },
                { day: 15, marks: [] },
                { day: 16, marks: [] },
                { day: 17, marks: [] },
                { day: 18, marks: [] },
                { day: 19, marks: [] }
              ]
            },
            {
              week: 4,
              days: [
                { day: 20, marks: [] },
                { day: 21, marks: [] },
                { day: 22, marks: [] },
                { day: 23, marks: [] },
                { day: 24, marks: [] },
                { day: 25, marks: [] },
                { day: 26, marks: [] }
              ]
            },
            {
              week: 5,
              days: [
                { day: 27, marks: [] },
                { day: 28, marks: [] },
                { day: 29, marks: [] },
                { day: 30, marks: [] },
                { day: 31, marks: [] }
              ]
            }
          ]
        }
      ]
    },
    {
      year: 2021,
      months: [
        {
          month: 0,
          firstWeekDay: 5,
          weeks: [
            {
              week: 1,
              days: [
                { day: 1, marks: [] },
                { day: 2, marks: [] }
              ]
            },
            {
              week: 2,
              days: [
                { day: 3, marks: [] },
                { day: 4, marks: [] },
                { day: 5, marks: [] },
                { day: 6, marks: [] },
                { day: 7, marks: [] },
                { day: 8, marks: [] },
                { day: 9, marks: [] }
              ]
            },
            {
              week: 3,
              days: [
                { day: 10, marks: [] },
                { day: 11, marks: [] },
                { day: 12, marks: [] },
                { day: 13, marks: [] },
                { day: 14, marks: [] },
                { day: 15, marks: [] },
                { day: 16, marks: [] }
              ]
            },
            {
              week: 4,
              days: [
                { day: 17, marks: [] },
                { day: 18, marks: [] },
                { day: 19, marks: [] },
                { day: 20, marks: [] },
                { day: 21, marks: [] },
                { day: 22, marks: [] },
                { day: 23, marks: [] }
              ]
            },
            {
              week: 5,
              days: [
                { day: 24, marks: [] },
                { day: 25, marks: [] },
                { day: 26, marks: [] },
                { day: 27, marks: [] },
                { day: 28, marks: [] },
                { day: 29, marks: [] },
                { day: 30, marks: [] },
              ]
            },
            {
              week: 6,
              days: [
                { day: 31, marks: [] }
              ]
            }
          ]
        }
      ]
    }
  ]
};
